/**
 * Słowniki tekstów interfejsu formularza. Klucze są wspólne dla obu języków —
 * `en` jest typowane po `pl`, więc brak tłumaczenia wychodzi na etapie kompilacji.
 *
 * Interpolacja: fragmenty `{{nazwa}}` podmieniane są przez t(key, { nazwa }).
 */
export const pl = {
    'title.page': 'iForms - formularz do umowy zlecenia',
    'lang.english': 'English version',
    'lang.polish': 'wersja polska',

    'loading.title': 'Ładowanie danych',
    'loading.body': 'Trwa weryfikacja tokenu oraz ładowanie formularza. Proszę czekać...',

    'error.expired.title': 'Przedatowany token',
    'error.expired.body': 'Ups! Troszeczkę za długo to trwało, a względy bezpieczeństwa są nieubłagane. Musimy wygenerować dostęp do formularza jeszcze raz. Napisz do nas na adres mailowy',
    'error.expired.after': 'a otrzymasz mail z linkiem do nowego formularza. Tym razem na pewno się uda!',
    'error.incorrect.title': 'Niepoprawny token',
    'error.incorrect.body': 'Hmmm… coś poszło nie tak. Musimy wygenerować dostęp do formularza jeszcze raz. Napisz do nas na adres',
    'error.incorrect.after': 'a otrzymasz mail z linkiem do nowego formularza. Tym razem na pewno się uda!',
    'error.used.title': 'Formularz został już użyty',
    'error.used.body': 'Hmmm… wygląda na to, że ten formularz został już raz użyty. Napisz do nas na adres mailowy',
    'error.used.after': 'a spróbujemy rozwiązać problem od ręki.',
    'error.server.title': 'Brak odpowiedzi ze strony serwera',
    'error.server.body': 'Halo, halo? Czy my się słyszymy? Mamy jakiś chwilowy problem techniczny z kontaktem z bazą. Napisz do nas na adres',
    'error.server.after': 'a spróbujemy rozwiązać problem komunikacji od ręki.',
    'error.missing.title': 'Brak tokenu',
    'error.missing.body': 'Nie znaleziono tokenu w linku. Proszę sprawdzić adres lub poprosić o nowy link.',

    'form.sent.title': 'Formularz został podpisany i wysłany!',
    'form.sent.body': 'Dziękujemy. Potwierdzenie z kopią formularza (PDF) wyślemy na Twój adres e-mail.',

    'sms.title': 'Potwierdź podpis kodem SMS',
    'sms.sending': 'Wysyłamy kod SMS…',
    'sms.sentTo': 'Wysłaliśmy 6-cyfrowy kod na numer {{phone}}. Wpisz go poniżej, aby podpisać formularz.',
    'sms.codeLabel': 'Kod z SMS',
    'sms.expiresIn': 'Kod wygasa za {{time}}',
    'sms.expired': 'Kod wygasł. Wyślij nowy kod.',
    'sms.resend': 'Wyślij ponownie',
    'sms.resendIn': 'Wyślij ponownie ({{seconds}} s)',
    'sms.confirm': 'Podpisz',
    'sms.verifying': 'Sprawdzamy kod…',
    'sms.submitting': 'Zapisujemy podpisany formularz…',
    'sms.cancel': 'Anuluj',
    'sms.attemptsLeft': 'Nieprawidłowy kod. Pozostało prób: {{count}}',
    'sms.locked': 'Przekroczono liczbę prób. Formularz został zablokowany — poproś o nowy link do formularza.',
    'sms.limit': 'Wysłano maksymalną liczbę kodów. Spróbuj ponownie za {{minutes}} min.',
    'sms.cooldown': 'Poczekaj {{seconds}} s przed ponowną wysyłką.',
    'sms.sendFailed': 'Nie udało się wysłać SMS-a. Spróbuj ponownie.',
    'sms.phoneMissing': 'W formularzu brakuje numeru telefonu. Skontaktuj się z nami: pomoc@itaxlabs.com',
    'sms.proofExpired': 'Weryfikacja wygasła. Wyślij kod jeszcze raz.',
    'sms.tooMany': 'Zbyt wiele prób. Odczekaj minutę i spróbuj ponownie.',
    'sms.formUnavailable': 'Ten formularz nie może już zostać podpisany (link wygasł lub został użyty).',
    'sms.genericError': 'Coś poszło nie tak. Spróbuj ponownie.',

    'sign.loading': 'Ładowanie dokumentu…',
    'sign.title': 'Dokument do podpisu',
    'sign.intro': '{{principal}} przekazał(a) Ci do podpisu dokument <strong>{{title}}</strong>. Zapoznaj się z jego treścią, potwierdź akceptację i podpisz jednorazowym kodem SMS.',
    'sign.signer': 'Podpisujący',
    'sign.validTill': 'Link ważny do',
    'sign.openPdf': 'Otwórz PDF w nowej karcie',
    'sign.accept': 'Oświadczam, że zapoznałem/am się z treścią dokumentu i akceptuję ją w całości. Podpisuję dokument jednorazowym kodem SMS wysłanym na mój numer telefonu.',
    'sign.signButton': 'Podpisz dokument',
    'sign.rejectButton': 'Odmawiam podpisu',
    'sign.rejectTitle': 'Odmowa podpisu',
    'sign.rejectIntro': 'Podaj powód odmowy — zostanie przekazany nadawcy dokumentu. Odmowę potwierdzisz jednorazowym kodem SMS.',
    'sms.consentRequired': 'Zaznacz oświadczenie o akceptacji treści dokumentu.',
    'sign.rejectReason': 'Powód (opcjonalnie)',
    'sign.rejectConfirm': 'Potwierdź odmowę',
    'sign.rejectCancel': 'Wróć',
    'sign.doneTitle': 'Dokument podpisany',
    'sign.doneBody': 'Dziękujemy. Gdy podpiszą wszystkie strony, otrzymasz e-mail z podpisanym egzemplarzem (PDF) i kartą podpisów.',
    'sign.doneMeta': 'Podpisano {{time}} · numer {{phone}}',
    'sign.rejectedTitle': 'Odmówiono podpisu',
    'sign.rejectedBody': 'Informacja o odmowie została przekazana nadawcy dokumentu.',
    'sign.unavailableTitle': 'Link jest nieaktywny',
    'sign.unavailableBody': 'Ten link do podpisu wygasł albo został wycofany. Skontaktuj się z nadawcą dokumentu, aby otrzymać nowy.',
    'sign.alreadyTitle': 'Dokument już obsłużony',
    'sign.alreadyBody': 'Ten dokument został już przez Ciebie podpisany albo odrzucony.',
    'sign.error': 'Nie udało się wykonać operacji. Spróbuj ponownie.',

    'form.intro.hello': 'Cześć,',
    'form.intro.line1': 'już tylko krok dzieli Cię od dołączenia do grona współpracowników Mystic Creatures Festival. Formalności.',
    'form.intro.line2a': 'Nikt ich nie lubi, ale są konieczne. ',
    'form.intro.line2bold': 'Poświęć 5 minut ',
    'form.intro.line2b': 'i wypełnij uważnie poniższy formularz. Na tej podstawie przygotujemy dokumenty, które podeślemy Ci do zapoznania się i podpisu. Do dzieła!',
    'form.errorsSummary': 'Proszę uzupełnić brakujące lub niepoprawne dane przed wysłaniem formularza.',
    'form.submit': 'Podpisz',
    'form.submitError': 'Wystąpił błąd podczas wysyłania formularza. Spróbuj ponownie.',

    'section.contractorData': 'Dane zleceniobiorcy',
    'section.billingDetails': 'Dane rozliczeniowe',
    'section.residentialAddress1': 'Adres zamieszkania dla',
    'section.residentialAddress2': 'celów rozliczeniowych',
    'section.zusStatements': 'Oświadczenie zleceniobiorcy niezbędne do ustalenia statusu ubezpieczeniowego ZUS',
    'section.bankAccount': 'Rachunek bankowy',
    'section.contractorStatement': 'Oświadczenie zleceniobiorcy',
    'section.companyData': 'Dane firmy',
    'section.representative': 'Przedstawiciel firmy',
    'section.registeredOffice': 'Adres siedziby',

    'field.firstName': 'Imię (Imiona)',
    'field.lastName': 'Nazwisko',
    'field.email': 'Adres e-mail',
    'field.phone': 'Numer Telefonu',
    'field.readOnly': 'To pole jest tylko do odczytu',
    'field.pesel': 'PESEL',
    'field.dateOfBirth': 'Data urodzenia',
    'field.citizenship': 'Obywatelstwo',
    'field.taxOffice': 'Urząd Skarbowy',
    'field.voivodeship': 'Województwo',
    'field.county': 'Powiat',
    'field.municipality': 'Gmina',
    'field.selectVoivodeshipFirst': 'Najpierw wybierz województwo',
    'field.selectVoivodeshipAndCountyFirst': 'Najpierw wybierz województwo i powiat',
    'field.selectCountyFirst': 'Najpierw wybierz powiat',
    'field.city': 'Miasto',
    'field.postalCode': 'Kod pocztowy',
    'field.street': 'Ulica',
    'field.houseNumber': 'Numer domu',
    'field.apartmentNumber': 'Numer lokalu',
    'field.companyName': 'Nazwa Firmy',
    'field.nip': 'NIP',
    'field.regon': 'REGON',
    'field.legalForm': 'Forma działalności',
    'field.repFirstName': 'Imię',
    'field.repLastName': 'Nazwisko',
    'field.repPosition': 'Funkcja',
    'field.iban': 'Numer konta (IBAN)',
    'field.ibanHint': 'Podaj 28-znakowy numer rachunku bankowego z prefiksem PL (np. PL61 1090 1014 0000 0712 1981 2874).',

    'st.socialInsurance': 'Jestem objęty obowiązkowo ubezpieczeniem społecznym z tytułu umowy o pracę zawartej z innym podmiotem',
    'st.entityNameAddress': 'Nazwa podmiotu i adres',
    'st.salaryAboveMin': 'Wynagrodzenie brutto z ww. stosunku pracy jest wyższe od minimalnego wynagrodzenia',
    'st.mandate': 'Jestem zatrudniony na podstawie umowy zlecenia zawartej z innym podmiotem',
    'st.mandateSalaryAboveMin': 'Wynagrodzenie brutto z tytułu ww. umowy zlecenia jest wyższe od minimalnego wynagrodzenia',
    'st.mandatePeriod': 'Okres, na który została zawarta umowa zlecenia od/do',
    'st.from': 'Od',
    'st.to': 'Do',
    'st.retired': 'Jestem emerytem',
    'st.pensioner': 'Jestem rencistą',
    'st.student': 'Jestem studentem',
    'st.studentIdNumber': 'Numer legitymacji studenckiej',
    'st.uploadStudentId': 'Wgraj skan legitymacji',
    'st.disability': 'Posiadam orzeczenie o niepełnosprawności',
    'st.disabilityDegree': 'Stopień niepełnosprawności',
    'degree.znaczny': 'znaczny',
    'degree.umiarkowany': 'umiarkowany',
    'degree.lekki': 'lekki',
    'st.voluntaryHealth': 'Proszę o objęcie mnie dobrowolnym ubezpieczeniem chorobowym',
    'st.business': 'Prowadzę działalność gospodarczą',
    'yes': 'TAK',
    'no': 'NIE',

    'agreement.dataAgreement': 'Oświadczam, że dane zawarte w kwestionariuszu są zgodne ze stanem rzeczywistym i zobowiązuję się do niezwłocznego poinformowania Mystic Creatures Festival Sp. z o.o. o ich każdorazowej zmianie.',
    'agreement.processingConsent': 'Wyrażam zgodę na przetwarzanie przez Mystic Creatures Festival Sp. z o.o. moich danych osobowych podanych w kwestionariuszu w celu zawarcia i wykonania umowy zawartej z Mystic Creatures Festival Sp. z o.o.',

    'gus.title': 'Pobierz dane z GUS',
    'gus.question': 'Czy zaczytać dane firmy z rejestru GUS na podstawie podanego NIP?',
    'gus.no': 'Nie',
    'gus.yes': 'Tak',
    'gus.loading': 'Pobieranie...',
    'gus.loaded': 'Dane z GUS zostały załadowane',
    'gus.timeout': 'Nie udało się zaczytać danych z GUS w wymaganym czasie. Proszę wprowadzić dane ręcznie.',
    'gus.notFound': 'Nie znaleziono danych w GUS dla podanego NIP. Proszę wprowadzić dane ręcznie.',

    // Formy prawne — wartość PL jest jednocześnie wartością zapisywaną w formularzu.
    'lf.jdg': 'Jednoosobowa działalność gospodarcza (JDG)',
    'lf.spolka_zoo': 'Spółka z ograniczoną odpowiedzialnością',
    'lf.spolka_cywilna': 'Spółka cywilna',
    'lf.spolka_jawna': 'Spółka jawna',
    'lf.spolka_partnerska': 'Spółka partnerska',
    'lf.spolka_komandytowa': 'Spółka komandytowa',
    'lf.spolka_komandytowo_akcyjna': 'Spółka komandytowo-akcyjna',
    'lf.prosta_spolka_akcyjna': 'Prosta spółka akcyjna',
    'lf.spolka_akcyjna': 'Spółka akcyjna',
    'lf.stowarzyszenie': 'Stowarzyszenie',
    'lf.fundacja': 'Fundacja',

    'v.required': 'To pole jest wymagane',
    'v.startDateRequired': 'Data rozpoczęcia jest wymagana',
    'v.endDateRequired': 'Data zakończenia jest wymagana',
    'v.nameMax100': 'Nazwa nie może mieć więcej niż 100 znaków',
    'v.entityNameRequired': 'Nazwa podmiotu jest wymagana',
    'v.studentIdRequired': 'Numer legitymacji jest wymagany',
    'v.studentIdScanRequired': 'Skan legitymacji jest wymagany',
    'v.studentIdScanUploadFailed': 'Nie udalo sie wyslac skanu legitymacji. Sprobuj ponownie albo wybierz inny plik (PDF, JPG lub PNG, do 5 MB).',
    'v.degreeRequired': 'Stopień niepełnosprawności jest wymagany',
    'v.voivodeshipRequired': 'Województwo jest wymagane',
    'v.countyRequired': 'Powiat jest wymagany',
    'v.municipalityRequired': 'Gmina jest wymagana',
    'v.peselRequired': 'Pesel jest wymagany',
    'v.pesel11': 'Pesel musi składać się z 11 cyfr',
    'v.peselInvalid': 'Niepoprawny numer PESEL',
    'v.citizenshipMin': 'Wybierz co najmniej jedno obywatelstwo',
    'v.citizenshipRequired': 'Obywatelstwo jest wymagane',
    'v.taxOfficeRequired': 'Urząd skarbowy jest wymagany',
    'v.firstNameRequired': 'Imię jest wymagane',
    'v.lastNameRequired': 'Nazwisko jest wymagane',
    'v.emailInvalid': 'Nieprawidłowy email',
    'v.emailRequired': 'Email jest wymagany',
    'v.phoneRequired': 'Numer telefonu jest wymagany',
    'v.phoneInvalid': 'Niepoprawny numer telefonu (PL)',
    'v.streetRequired': 'Ulica jest wymagana',
    'v.postalRequired': 'Kod pocztowy jest wymagany',
    'v.postalFormat': 'Kod pocztowy musi być w formacie 00-000',
    'v.cityRequired': 'Miasto jest wymagane',
    'v.houseRequired': 'Numer domu jest wymagany',
    'v.houseMax': 'Numer domu nie może być dłuższy niż 6 znaków',
    'v.aptMax': 'Numer mieszkania nie może być dłuższy niż 6 znaków',
    'v.companyNameRequired': 'Nazwa firmy jest wymagana',
    'v.nipRequired': 'NIP jest wymagany',
    'v.nipInvalid': 'Nieprawidłowy NIP',
    'v.regonRequired': 'REGON jest wymagany',
    'v.regonInvalid': 'Nieprawidłowy REGON',
    'v.legalFormRequired': 'Forma prawna jest wymagana',
    'v.repFirstNameRequired': 'Imię przedstawiciela jest wymagane',
    'v.repLastNameRequired': 'Nazwisko przedstawiciela jest wymagane',
    'v.repPositionRequired': 'Funkcja przedstawiciela jest wymagana',

    'iban.required': 'Numer konta jest wymagany',
    'iban.charset': 'Numer może zawierać tylko litery i cyfry',
    'iban.noPrefix': 'Brak prefiksu kraju - numer powinien zaczynać się od PL',
    'iban.unknownCountry': 'Nieznany kod kraju "{{country}}"',
    'iban.invalid': 'Numer rachunku jest niepoprawny',
    'iban.tooShort': 'Numer jest za krótki',
    'iban.tooLong': 'Numer jest za długi',
};

export type TranslationKey = keyof typeof pl;

export const en: Record<TranslationKey, string> = {
    'title.page': 'iForms - contract of mandate form',
    'lang.english': 'English version',
    'lang.polish': 'wersja polska',

    'loading.title': 'Loading data',
    'loading.body': 'Verifying the token and loading the form. Please wait...',

    'error.expired.title': 'Expired token',
    'error.expired.body': 'Oops! That took a little too long, and security rules are unforgiving. We need to generate access to the form again. Write to us at',
    'error.expired.after': 'and you will receive an e-mail with a link to a new form. This time it will surely work!',
    'error.incorrect.title': 'Invalid token',
    'error.incorrect.body': 'Hmm… something went wrong. We need to generate access to the form again. Write to us at',
    'error.incorrect.after': 'and you will receive an e-mail with a link to a new form. This time it will surely work!',
    'error.used.title': 'This form has already been used',
    'error.used.body': 'Hmm… it looks like this form has already been used. Write to us at',
    'error.used.after': 'and we will try to solve the problem right away.',
    'error.server.title': 'No response from the server',
    'error.server.body': 'Hello? Can you hear us? We are having a temporary technical problem connecting to the database. Write to us at',
    'error.server.after': 'and we will try to fix the connection problem right away.',
    'error.missing.title': 'Missing token',
    'error.missing.body': 'No token was found in the link. Please check the address or ask for a new link.',

    'form.sent.title': 'The form has been signed and sent!',
    'form.sent.body': 'Thank you. We will send a confirmation with a PDF copy of the form to your e-mail address.',

    'sms.title': 'Confirm your signature with an SMS code',
    'sms.sending': 'Sending the SMS code…',
    'sms.sentTo': 'We sent a 6-digit code to {{phone}}. Enter it below to sign the form.',
    'sms.codeLabel': 'SMS code',
    'sms.expiresIn': 'The code expires in {{time}}',
    'sms.expired': 'The code has expired. Request a new code.',
    'sms.resend': 'Resend code',
    'sms.resendIn': 'Resend ({{seconds}} s)',
    'sms.confirm': 'Sign',
    'sms.verifying': 'Checking the code…',
    'sms.submitting': 'Saving the signed form…',
    'sms.cancel': 'Cancel',
    'sms.attemptsLeft': 'Incorrect code. Attempts left: {{count}}',
    'sms.locked': 'Too many failed attempts. The form has been locked — please request a new form link.',
    'sms.limit': 'Maximum number of codes sent. Try again in {{minutes}} min.',
    'sms.cooldown': 'Wait {{seconds}} s before resending.',
    'sms.sendFailed': 'The SMS could not be sent. Please try again.',
    'sms.phoneMissing': 'The form has no phone number. Contact us: pomoc@itaxlabs.com',
    'sms.proofExpired': 'The verification has expired. Request the code again.',
    'sms.tooMany': 'Too many requests. Wait a minute and try again.',
    'sms.formUnavailable': 'This form can no longer be signed (the link has expired or was already used).',
    'sms.genericError': 'Something went wrong. Please try again.',

    'sign.loading': 'Loading the document…',
    'sign.title': 'Document to sign',
    'sign.intro': '{{principal}} has sent you the document <strong>{{title}}</strong> to sign. Read its content, confirm your acceptance and sign it with a one-time SMS code.',
    'sign.signer': 'Signer',
    'sign.validTill': 'Link valid until',
    'sign.openPdf': 'Open the PDF in a new tab',
    'sign.accept': 'I declare that I have read the content of the document and accept it in full. I am signing the document with a one-time SMS code sent to my phone number.',
    'sign.signButton': 'Sign the document',
    'sign.rejectButton': 'I refuse to sign',
    'sign.rejectTitle': 'Refusal to sign',
    'sign.rejectIntro': 'Provide the reason for the refusal — it will be passed on to the sender of the document. You will confirm the refusal with a one-time SMS code.',
    'sms.consentRequired': 'Please tick the declaration accepting the content of the document.',
    'sign.rejectReason': 'Reason (optional)',
    'sign.rejectConfirm': 'Confirm refusal',
    'sign.rejectCancel': 'Back',
    'sign.doneTitle': 'Document signed',
    'sign.doneBody': 'Thank you. Once all parties have signed, you will receive an e-mail with the signed copy (PDF) and the signature card.',
    'sign.doneMeta': 'Signed {{time}} · number {{phone}}',
    'sign.rejectedTitle': 'Signature refused',
    'sign.rejectedBody': 'The sender of the document has been informed about the refusal.',
    'sign.unavailableTitle': 'This link is inactive',
    'sign.unavailableBody': 'This signing link has expired or has been withdrawn. Contact the sender of the document to receive a new one.',
    'sign.alreadyTitle': 'Document already handled',
    'sign.alreadyBody': 'You have already signed or rejected this document.',
    'sign.error': 'The operation could not be completed. Please try again.',

    'form.intro.hello': 'Hi,',
    'form.intro.line1': 'you are just one step away from joining the Mystic Creatures Festival team. Formalities.',
    'form.intro.line2a': 'Nobody likes them, but they are necessary. ',
    'form.intro.line2bold': 'Take 5 minutes ',
    'form.intro.line2b': 'and carefully fill in the form below. Based on it, we will prepare the documents and send them to you for review and signature. Let\'s go!',
    'form.errorsSummary': 'Please complete the missing or incorrect data before submitting the form.',
    'form.submit': 'Sign',
    'form.submitError': 'An error occurred while sending the form. Please try again.',

    'section.contractorData': 'Contractor details',
    'section.billingDetails': 'Billing details',
    'section.residentialAddress1': 'Residential address',
    'section.residentialAddress2': 'for billing purposes',
    'section.zusStatements': 'Contractor\'s declaration required to determine ZUS (social insurance) status',
    'section.bankAccount': 'Bank account',
    'section.contractorStatement': 'Contractor\'s declaration',
    'section.companyData': 'Company details',
    'section.representative': 'Company representative',
    'section.registeredOffice': 'Registered office address',

    'field.firstName': 'First name(s)',
    'field.lastName': 'Last name',
    'field.email': 'E-mail address',
    'field.phone': 'Phone number',
    'field.readOnly': 'This field is read-only',
    'field.pesel': 'PESEL',
    'field.dateOfBirth': 'Date of birth',
    'field.citizenship': 'Citizenship',
    'field.taxOffice': 'Tax office',
    'field.voivodeship': 'Voivodeship',
    'field.county': 'County',
    'field.municipality': 'Municipality',
    'field.selectVoivodeshipFirst': 'Select a voivodeship first',
    'field.selectVoivodeshipAndCountyFirst': 'Select a voivodeship and county first',
    'field.selectCountyFirst': 'Select a county first',
    'field.city': 'City',
    'field.postalCode': 'Postal code',
    'field.street': 'Street',
    'field.houseNumber': 'House number',
    'field.apartmentNumber': 'Apartment number',
    'field.companyName': 'Company name',
    'field.nip': 'NIP (tax ID)',
    'field.regon': 'REGON',
    'field.legalForm': 'Legal form',
    'field.repFirstName': 'First name',
    'field.repLastName': 'Last name',
    'field.repPosition': 'Position',
    'field.iban': 'Account number (IBAN)',
    'field.ibanHint': 'Enter the 28-character bank account number with the PL prefix (e.g. PL61 1090 1014 0000 0712 1981 2874).',

    'st.socialInsurance': 'I am covered by compulsory social insurance under an employment contract with another entity',
    'st.entityNameAddress': 'Entity name and address',
    'st.salaryAboveMin': 'The gross salary from the above employment is higher than the minimum wage',
    'st.mandate': 'I am employed under a contract of mandate with another entity',
    'st.mandateSalaryAboveMin': 'The gross remuneration from the above contract of mandate is higher than the minimum wage',
    'st.mandatePeriod': 'Period for which the contract of mandate was concluded (from/to)',
    'st.from': 'From',
    'st.to': 'To',
    'st.retired': 'I am a retiree (old-age pensioner)',
    'st.pensioner': 'I receive a disability pension',
    'st.student': 'I am a student',
    'st.studentIdNumber': 'Student ID number',
    'st.uploadStudentId': 'Upload a scan of your student ID',
    'st.disability': 'I hold a disability certificate',
    'st.disabilityDegree': 'Degree of disability',
    'degree.znaczny': 'significant',
    'degree.umiarkowany': 'moderate',
    'degree.lekki': 'mild',
    'st.voluntaryHealth': 'I request voluntary sickness insurance coverage',
    'st.business': 'I run a business',
    'yes': 'YES',
    'no': 'NO',

    'agreement.dataAgreement': 'I declare that the data contained in the questionnaire is true and I undertake to immediately inform Mystic Creatures Festival Sp. z o.o. of any change.',
    'agreement.processingConsent': 'I consent to the processing by Mystic Creatures Festival Sp. z o.o. of my personal data provided in the questionnaire for the purpose of concluding and performing the agreement with Mystic Creatures Festival Sp. z o.o.',

    'gus.title': 'Fetch data from GUS',
    'gus.question': 'Load company data from the GUS register based on the provided NIP?',
    'gus.no': 'No',
    'gus.yes': 'Yes',
    'gus.loading': 'Loading...',
    'gus.loaded': 'Data from GUS has been loaded',
    'gus.timeout': 'Could not load data from GUS in time. Please enter the data manually.',
    'gus.notFound': 'No data found in GUS for the given NIP. Please enter the data manually.',

    'lf.jdg': 'Sole proprietorship (JDG)',
    'lf.spolka_zoo': 'Limited liability company (sp. z o.o.)',
    'lf.spolka_cywilna': 'Civil partnership',
    'lf.spolka_jawna': 'General partnership',
    'lf.spolka_partnerska': 'Professional partnership',
    'lf.spolka_komandytowa': 'Limited partnership',
    'lf.spolka_komandytowo_akcyjna': 'Limited joint-stock partnership',
    'lf.prosta_spolka_akcyjna': 'Simple joint-stock company',
    'lf.spolka_akcyjna': 'Joint-stock company',
    'lf.stowarzyszenie': 'Association',
    'lf.fundacja': 'Foundation',

    'v.required': 'This field is required',
    'v.startDateRequired': 'Start date is required',
    'v.endDateRequired': 'End date is required',
    'v.nameMax100': 'Name cannot be longer than 100 characters',
    'v.entityNameRequired': 'Entity name is required',
    'v.studentIdRequired': 'Student ID number is required',
    'v.studentIdScanRequired': 'Student ID scan is required',
    'v.studentIdScanUploadFailed': 'Could not upload the student ID scan. Try again or pick another file (PDF, JPG or PNG, up to 5 MB).',
    'v.degreeRequired': 'Degree of disability is required',
    'v.voivodeshipRequired': 'Voivodeship is required',
    'v.countyRequired': 'County is required',
    'v.municipalityRequired': 'Municipality is required',
    'v.peselRequired': 'PESEL is required',
    'v.pesel11': 'PESEL must consist of 11 digits',
    'v.peselInvalid': 'Invalid PESEL number',
    'v.citizenshipMin': 'Select at least one citizenship',
    'v.citizenshipRequired': 'Citizenship is required',
    'v.taxOfficeRequired': 'Tax office is required',
    'v.firstNameRequired': 'First name is required',
    'v.lastNameRequired': 'Last name is required',
    'v.emailInvalid': 'Invalid e-mail address',
    'v.emailRequired': 'E-mail is required',
    'v.phoneRequired': 'Phone number is required',
    'v.phoneInvalid': 'Invalid phone number (PL format)',
    'v.streetRequired': 'Street is required',
    'v.postalRequired': 'Postal code is required',
    'v.postalFormat': 'Postal code must be in the format 00-000',
    'v.cityRequired': 'City is required',
    'v.houseRequired': 'House number is required',
    'v.houseMax': 'House number cannot be longer than 6 characters',
    'v.aptMax': 'Apartment number cannot be longer than 6 characters',
    'v.companyNameRequired': 'Company name is required',
    'v.nipRequired': 'NIP is required',
    'v.nipInvalid': 'Invalid NIP',
    'v.regonRequired': 'REGON is required',
    'v.regonInvalid': 'Invalid REGON',
    'v.legalFormRequired': 'Legal form is required',
    'v.repFirstNameRequired': 'Representative\'s first name is required',
    'v.repLastNameRequired': 'Representative\'s last name is required',
    'v.repPositionRequired': 'Representative\'s position is required',

    'iban.required': 'Account number is required',
    'iban.charset': 'The number may contain only letters and digits',
    'iban.noPrefix': 'Missing country prefix - the number should start with PL',
    'iban.unknownCountry': 'Unknown country code "{{country}}"',
    'iban.invalid': 'The account number is invalid',
    'iban.tooShort': 'The number is too short',
    'iban.tooLong': 'The number is too long',
};

export type Language = 'pl' | 'en';

export const translations: Record<Language, Record<TranslationKey, string>> = { pl, en };
